import { render, staticRenderFns } from "./MailContactTypes.vue?vue&type=template&id=59916723&"
import script from "./MailContactTypes.vue?vue&type=script&lang=js&"
export * from "./MailContactTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports